import 'reflect-metadata';
import {PagesService} from '../services/pages.service';


export const Page = (pageName: string, header: string, rightId?: number, data?: any) => {
  return (target) => {
    PagesService.componentsList[pageName] = {type: target, header, rightId, data};
  };
};
